module.exports = __webpack_public_path__ + "static/media/rbcr.c4f910ea.png";